import { themeAtom } from "../../shared/atoms";
import { formatDate } from "../../shared/services/utils";
import { TechForm } from "../models/tech-form.model";
import { FlagIcon } from "./FlagIcon";
import { TechFormsPendingPlaceholder } from "./TechFormsPendingPlaceholder";
import ProgressBar from "./progress";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { NavigateFunction, useNavigate } from "react-router";
import { twMerge } from "tailwind-merge";

interface Props {
  forms: TechForm[];
  lsVesselName: any;
  lsImoNumber: any;
  stepno: number;
  openForm: (form: TechForm, navigate: NavigateFunction) => void;
}

export const TechFormsPending: React.FC<Props> = ({ forms, lsVesselName, lsImoNumber, stepno, openForm }) => {
  const theme = useAtomValue(themeAtom);

  const navigate = useNavigate();
  const isSameDraftVessel = (form: TechForm) =>
    String(lsVesselName ?? "") === String(form.VESSEL_NAME ?? "") &&
    String(lsImoNumber ?? "") === String(form.IMO_NUMBER ?? "");

  return (
    <div
      className={twMerge(
        "flex h-80 flex-col overflow-auto rounded-lg",
        theme.certVesselSelect.tableBg,
        "[&::-webkit-scrollbar]:w-1.5",
        "[&::-webkit-scrollbar-track]:bg-transparent",
        "[&::-webkit-scrollbar-thumb]:rounded-full",
        theme.uwhcAssistant.tableScroll,
        theme.uwhcAssistant.scrolHover,
      )}
    >
      {forms?.map((form, i) => (
        <div
          key={i}
          className={twMerge(
            "e m-2 inline-flex cursor-pointer items-center justify-start gap-4 self-stretch rounded-lg border p-4",
            theme.certVesselSelect.tableBg,
            theme.myVesselsTable.tailwind.tableBorder,
            theme.myVesselsTableRow.row.hover,
          )}
          onClick={() => openForm(form, navigate)}
        >
          <div className="inline-flex shrink grow basis-0 flex-col items-start justify-start gap-1">
            <div
              className={twMerge(
                "flex flex-col items-start justify-start gap-2.5 rounded-[99px] border-2",
                theme.uwhcAssistant.buttonBorder,
              )}
            >
              <div
                className={twMerge(
                  "inline-flex items-center justify-start gap-1 rounded-[99px] px-2 py-1",
                  theme.uwhcAssistant.tableBgOther,
                )}
              >
                <div className="relative h-4 w-4">
                  <FlagIcon className={twMerge("mr-2", theme.home.tailwind.textDefault)} />
                </div>
                <div
                  className={twMerge("text-center text-xs font-medium leading-none", theme.home.tailwind.textDefault)}
                >
                  New
                </div>
              </div>
            </div>
            <div className="inline-flex items-center justify-start gap-2 self-stretch">
              <div className={twMerge("text-sm font-bold leading-tight", theme.home.tailwind.textDefault)}>
                {form.TYPE === "TECH" ? "Technical" : "Baltic"} form
              </div>
            </div>
            <div
              className={twMerge(
                "self-stretch text-[11px] font-normal leading-[13.75px]",
                theme.home.tailwind.textDefault,
              )}
            >
              Requested on the {formatDate(form?.REQUESTED_ON)}
            </div>
          </div>
          <div className="flex items-center justify-center">
            {isSameDraftVessel(form) && (
              <div className="text-[11px] font-normal leading-[13.75px] text-lightGrey">{stepno}/9</div>
            )}

            <div className="flex items-center justify-center gap-2 rounded px-4 py-2">
              {isSameDraftVessel(form) && <ProgressBar value={stepno} max={9} />}
              <div className="relative h-4 w-4">
                <ArrowRightIcon className="mr-2 h-4 w-4 pt-1 text-green" />
              </div>
            </div>
          </div>
        </div>
      ))}

      {forms.length < 1 && <TechFormsPendingPlaceholder />}
    </div>
  );
};
